import api
from '../../../api/apiService';

import {
  ENDPOINTS,
} from '../../../api/endpoints';

import type {
  SpanOfControlHeaderRequest,
  SpanOfControlHeaderResponse,
} from '../types/spanOfControl.types';

/**
 * =========================================
 * GET SPAN OF CONTROL HEADER
 * =========================================
 */
export const getSpanOfControlHeader =
  async (
    payload: SpanOfControlHeaderRequest,
  ): Promise<SpanOfControlHeaderResponse> => {

    const response =
      await api.post(
        ENDPOINTS.SPAN_OF_CONTROL_HEADER,
        payload,
      );

      console.log("SPAN_OF_CONTROL_HEADER",payload);
    return response.data;
  };